/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ContactStateSettingsCreate } from '../models/ContactStateSettingsCreate';
import type { ContactStateSettingsResponse } from '../models/ContactStateSettingsResponse';
import type { ContactStateSettingsUpdate } from '../models/ContactStateSettingsUpdate';
import type { StateActionResponse } from '../models/StateActionResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ContactStateSettingsService {
    /**
     * List Contact State Versions
     * @param campaignId
     * @returns ContactStateSettingsResponse Successful Response
     * @throws ApiError
     */
    public static listContactStateVersionsApiCampaignsCampaignIdContactStateSettingsGet(
        campaignId: string,
    ): CancelablePromise<Array<ContactStateSettingsResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/campaigns/{campaign_id}/contact-state-settings',
            path: {
                'campaign_id': campaignId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Contact State Version
     * @param campaignId
     * @param requestBody
     * @returns ContactStateSettingsResponse Successful Response
     * @throws ApiError
     */
    public static createContactStateVersionApiCampaignsCampaignIdContactStateSettingsPost(
        campaignId: string,
        requestBody: ContactStateSettingsCreate,
    ): CancelablePromise<ContactStateSettingsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/campaigns/{campaign_id}/contact-state-settings',
            path: {
                'campaign_id': campaignId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Active Contact State Settings
     * Edit the active version's catalog in place (no new version). Use POST to
     * snapshot a new version instead.
     * @param campaignId
     * @param requestBody
     * @returns ContactStateSettingsResponse Successful Response
     * @throws ApiError
     */
    public static updateActiveContactStateSettingsApiCampaignsCampaignIdContactStateSettingsPut(
        campaignId: string,
        requestBody: ContactStateSettingsUpdate,
    ): CancelablePromise<ContactStateSettingsResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/campaigns/{campaign_id}/contact-state-settings',
            path: {
                'campaign_id': campaignId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Active Contact State Settings
     * @param campaignId
     * @returns ContactStateSettingsResponse Successful Response
     * @throws ApiError
     */
    public static getActiveContactStateSettingsApiCampaignsCampaignIdContactStateSettingsActiveGet(
        campaignId: string,
    ): CancelablePromise<ContactStateSettingsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/campaigns/{campaign_id}/contact-state-settings/active',
            path: {
                'campaign_id': campaignId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Activate Contact State Version
     * @param campaignId
     * @param version
     * @returns ContactStateSettingsResponse Successful Response
     * @throws ApiError
     */
    public static activateContactStateVersionApiCampaignsCampaignIdContactStateSettingsVersionActivatePost(
        campaignId: string,
        version: number,
    ): CancelablePromise<ContactStateSettingsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/campaigns/{campaign_id}/contact-state-settings/{version}/activate',
            path: {
                'campaign_id': campaignId,
                'version': version,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Contact State Actions
     * The in-code action registry the custom-state editor's dropdown uses.
     * @returns StateActionResponse Successful Response
     * @throws ApiError
     */
    public static listContactStateActionsApiCampaignsContactStateActionsGet(): CancelablePromise<Array<StateActionResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/campaigns/contact-state-actions',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
